<template>
    <div>
        <font-awesome-icon v-if="isLoading" icon="spinner" spin/>
        <b-collapse v-else :visible="true" appear>
            <b-collapse :visible="true" v-if="!dispatchRequestFilters.dispatchDateGroup">
                <b-row>
                    <b-col cols="12" md="4">
                        <b-card class="mb-2">
                            <b-card-title>SELECTEER TYPE ORDERS</b-card-title>

                            <b-form>
                                <b-table-simple small>
                                    <b-thead>
                                        <tr>
                                            <th></th>
                                            <th class="text-center">{{DISPATCH_DATE_GROUPS.overdue}}</th>
                                            <th class="text-center">{{DISPATCH_DATE_GROUPS.today}}</th>
                                            <th class="text-center">{{DISPATCH_DATE_GROUPS.next_day}}</th>
                                        </tr>
                                    </b-thead>
                                    <b-tbody>
                                        <tr v-for="batchType in batchTypesWithOrderCountsFiltered">
                                            <th>{{ batchType.display_name }}</th>
                                            <td v-for="(name, group) in DISPATCH_DATE_GROUPS" class="text-center">
                                                <b-button v-if="batchType.dispatch_requests[group]" variant="link" size="sm" class="py-0 px-1 font-size-lg"
                                                          @click="selectDispatchRequestFilters(batchType.identifier, group)"
                                                >
                                                    {{batchType.dispatch_requests[group]}}
                                                </b-button>
                                                <span v-else>0</span>
                                            </td>
                                        </tr>
                                        <tr v-if="!batchTypesWithOrderCountsFiltered.length">
                                            <td colspan="3" class="pt-4">
                                                <i>Geen orders gevonden</i>
                                            </td>
                                        </tr>
                                    </b-tbody>
                                </b-table-simple>
                            </b-form>
                        </b-card>

                        <div class="ml-2 font-size-lg"><i>OF</i></div>

                        <b-card class="my-2">
                            <b-card-title>BATCH SPECIFIEKE ORDER</b-card-title>

                            <b-form @submit.prevent="getDispatchRequestForSpecificOrder">
                                <b-input v-model.trim="orderIdentifier" type="text"
                                         style="width:220px;" class="d-inline-block mr-2"
                                         required :disabled="isCreating || isCreatingFromSpecificOrder" placeholder="order nummer" autocomplete="off"
                                />
                                <b-button class="bg-midnight-bloom text-white" type="submit" :disabled="isCreating || isCreatingFromSpecificOrder">
                                    <font-awesome-icon v-if="isCreatingFromSpecificOrder" icon="spinner" spin/>
                                    <span v-else>Aanmaken</span>
                                </b-button>
                            </b-form>
                        </b-card>
                    </b-col>
                </b-row>
            </b-collapse>

            <font-awesome-icon v-else-if="isLoadingSortLocations" icon="spinner" spin/>

            <div v-else>
                <b-row class="mb-3">
                    <b-col>
                        <h3>
                            Orders:
                            <span class="text-info">{{ selectedBatchType.display_name }} </span>
                            <span class="align-text-top">&rarr;</span>
                            <span class="text-info">{{ DISPATCH_DATE_GROUPS[dispatchRequestFilters.dispatchDateGroup] }}</span>
                            <b-button variant="link" size="sm" class="p-0 ml-4" @click="resetDispatchRequestFilters">wijzig</b-button>
                        </h3>
                    </b-col>
                </b-row>

                <b-row class="mb-4">
                    <b-col cols="12" md="3">
                        <b-card class="mb-4">
                            <b-card-title>INFORMATIE</b-card-title>

                            <b-table-simple style="width:300px;" borderless head-row-variant="light">
                                <b-tr>
                                    <b-td><strong>Totaal aantal orders:</strong></b-td>
                                    <b-td>{{dispatchRequests.length}}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>Aantal orders voor geselecteerde pickzones:</strong></b-td>
                                    <b-td>{{ dispatchRequestsInSelectedPickZones.length }}</b-td>
                                </b-tr>
                            </b-table-simple>
                        </b-card>

                        <b-card class="mb-2">
                            <b-card-title>
                                BATCH AANTAL ORDERS
                                <font-awesome-icon icon="question-circle" title="Als je een getal kiest dat lager is dan het aantal geselecteerde orders worden de orders met de oudste dispatchdatum eerst gekozen." class="text-primary ml-2"/>
                            </b-card-title>

                            <b-form @submit.prevent="getDispatchRequestForRecentOrders">
                                <b-input v-model.number="recentOrderCount" type="number" min="1" :max="dispatchRequestsInSelectedPickZones.length"
                                         style="width:90px;" class="d-inline-block mr-2"
                                         required :disabled="isCreating" placeholder="aantal" autocomplete="off"
                                />
                                <b-button type="submit" class="bg-midnight-bloom text-white" :disabled="!isCreateFromRecentOrdersButtonEnabled">
                                    <font-awesome-icon v-if="isCreatingFromRecentOrders" icon="spinner" spin/>
                                    <span v-else>Aanmaken</span>
                                </b-button>
                            </b-form>
                        </b-card>
                    </b-col>
                    <b-col cols="12" md="9">
                        <b-card>
                            <b-card-title class="mb-4"><h5><strong>KIES PICKZONES</strong></h5></b-card-title>

                            <font-awesome-icon v-if="isLoadingSortLocations" icon="spinner" spin/>
                            <b-row v-else>
                                <b-col cols="6" v-for="pickZonesChunk in pickZonesChunked" :key="pickZonesChunk[0].id">
                                    <b-table-simple small>
                                        <colgroup>
                                            <col style="width:50px;"/>
                                            <col style="width:150px;"/>
                                            <col/>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th>Aantal orders</th>
                                            <th>Pickzone</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="pickZone in pickZonesChunk" :class="{'pickzone-selected': isZoneSelected(pickZone)}" :key="pickZone.id">
                                            <td>
                                                <b-checkbox size="lg" switch @input="toggleZone(pickZone)"/>
                                            </td>
                                            <td>{{ pickZone.drqCount }}</td>
                                            <td>
                                                <span v-html="pickZone.display_name" class="font-size-lg"/>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import PageTitle from "../../components/PageTitle.vue";
import moment from "moment";
import _ from "lodash"

const DISPATCH_DATE_GROUPS = {
    overdue: 'Te laat',
    today: 'Vandaag',
    next_day: 'Volgende werkdag',
}
export default {
    name: "ShipmentBatchCreate",
    components: {PageTitle},

    props: {
        location: {required: true, type: Object},
    },

    data() {
        return {
            isLoading: true,
            isLoadingSortLocations: true,
            isCreating: false,
            isCreatingFromRecentOrders: false,
            isCreatingFromSpecificOrder: false,
            hideZoneSelectModal: true,
            totalOrderCount: null,
            orderForSelectedPickZonesCount: null,
            dispatchRequestFilters: {
                batchTypeIdentifier: null,
                dispatchDateGroup: null,
            },
            recentOrderCount: '',
            orderIdentifier: '',
            batchTypesWithOrderCounts: [],
            dispatchRequests: [],
            pickZones: [],
            selectedPickZones: [],
            DISPATCH_DATE_GROUPS: DISPATCH_DATE_GROUPS,
        }
    },

    computed: {
        selectedBatchType() {
            const type = this.batchTypesWithOrderCounts.find(t => t.identifier === this.dispatchRequestFilters.batchTypeIdentifier)
            return (type) ? type : {}
        },
        selectedPickZoneCombinations() {
            return this.selectedPickZones.map(z => Object.values(z.ids))
        },
        dispatchRequestsInSelectedPickZones() {
            return this.dispatchRequests
                .filter(drq => {
                    let pickZones = this.getPickZonesForDispatchRequest(drq)

                    // Return true if there is a pickZoneCombination in the array that has the same number of pickZones as the DRQ and they're all present in the DRQ's pickZones
                    return this.selectedPickZoneCombinations.some(selectedZoneCombination => {
                        return pickZones.length === selectedZoneCombination.length
                            && pickZones.every(zone => selectedZoneCombination.indexOf(zone) !== -1)
                    })
                })
        },
        hasDispatchRequestsWithoutPickZone() {
            return this.dispatchRequests.some(drq => drq.dispatch_request_lines.some(line => !line.storage_location))
        },
        pickZoneCombinationsWithDispatchRequests() {
            let combinations = {}
            this.dispatchRequests.forEach(drq => {
                let combination = this.getPickZonesForDispatchRequest(drq)
                combinations[JSON.stringify(combination)] = combinations[JSON.stringify(combination)]
                    ? combinations[JSON.stringify(combination)] + 1
                    : 1
            })

            return combinations
        },
        pickZonesChunked() {
            return _.chunk(this.pickZones, 10)
        },
        batchTypesWithOrderCountsFiltered() {
            return this.batchTypesWithOrderCounts
                .filter(b => Object.values(b.dispatch_requests).some(c => c > 0))
        },
        isCreateFromRecentOrdersButtonEnabled() {
            return !this.isCreating && this.selectedPickZones.length
        },
    },

    mounted() {
        this.getBatchTypesWithOrderCounts()
            .then(() => this.isLoading = false)
    },

    methods: {
        async getBatchTypesWithOrderCounts() {
            return this.$http.get(`/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}/batch-types?include=batchable_order_counts`)
                .then(response => {
                    return this.batchTypesWithOrderCounts = response.data
                })
        },
        selectDispatchRequestFilters(batchTypeIdentifier, dispatchDateGroup) {
            this.isLoadingSortLocations = true

            this.dispatchRequestFilters.batchTypeIdentifier = batchTypeIdentifier
            this.dispatchRequestFilters.dispatchDateGroup = dispatchDateGroup

            let searchParams = {
                suggested_batch_type: batchTypeIdentifier,
            }

            switch (DISPATCH_DATE_GROUPS[dispatchDateGroup]) {
                case DISPATCH_DATE_GROUPS.overdue:
                    searchParams.dispatch_date_to = moment().format('YYYY-MM-DD')
                    break
                case DISPATCH_DATE_GROUPS.today:
                    searchParams.dispatch_date_from = moment().format('YYYY-MM-DD')
                    searchParams.dispatch_date_to = moment().add(1, 'day').format('YYYY-MM-DD')
                    break
                case DISPATCH_DATE_GROUPS.tomorrow:
                    searchParams.dispatch_date_from = moment().add(1, 'day').format('YYYY-MM-DD')
                    searchParams.dispatch_date_to = moment().add(2, 'days').format('YYYY-MM-DD')
                    break
            }
            
            this.getDispatchRequests(searchParams)
                .then(() => {
                    this.getPickZones()
                        .then(() => this.isLoadingSortLocations = false)
                })
        },
        resetDispatchRequestFilters() {
            this.dispatchRequestFilters.batchTypeIdentifier = null
            this.dispatchRequestFilters.dispatchDateGroup = null
            this.pickZones = []
        },
        getDispatchRequestForRecentOrders() {
            this.isCreatingFromRecentOrders = true
            this.createBatch(
                this.dispatchRequestsInSelectedPickZones.slice(0, this.recentOrderCount),
                this.dispatchRequestFilters.batchTypeIdentifier
            )
        },
        getDispatchRequestForSpecificOrder() {
            this.isCreatingFromSpecificOrder = true

            this.getDispatchRequests()
                .then(() => {
                    const foundDispatchRequest = this.dispatchRequests.find(drq => drq.sales_order.identifier === this.orderIdentifier)
                    if (!foundDispatchRequest) {
                        this.resetLoading()
                        return this.$alert(`Order niet gevonden`, 'danger')
                    }

                    const batchTypeIdentifier = this.batchTypesWithOrderCounts.find(t => t.id === foundDispatchRequest.suggested_batch_type_id).identifier
                    this.createBatch([foundDispatchRequest], batchTypeIdentifier)
                })
        },
        getDispatchRequests(searchParams) {
            return this.$http.get(`/api/rest/dispatch-requests`, {
                params: {
                    ...searchParams,
                    fields: 'id,identifier,sales_order_id',
                    include: [
                        'dispatch_request_lines:product_identifier',
                        'dispatch_request_lines.storage_location',
                        'sales_order:identifier'
                    ].join(';'),
                    dispatcher_identifier: this.location.identifier,
                    dispatcher_type: this.location.location_type.identifier,
                    is_batchable: 1,
                    status: this.$store.state.config.batching["batchable-statuses"],
                    sort_by: 'dispatch_date,id', // we willen de vroegst uit te leveren orders eerst batchen
                    sort_dir: 'asc,asc',
                },
            })
                .then(response => {
                    this.dispatchRequests = response.data
                })
        },
        resetLoading() {
            this.isCreating = false
            this.isCreatingFromRecentOrders = false
            this.isCreatingFromSpecificOrder = false
        },
        createBatch(dispatchRequests, batchTypeIdentifier) {
            this.isCreating = true
            this.$http.post(`/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}/dispatch-request-batches`, {
                dispatcher_identifier: this.location.identifier,
                dispatcher_type: this.location.location_type.identifier,
                batch_type: batchTypeIdentifier,
                dispatch_requests: dispatchRequests.map(drq => drq.identifier),
            })
                .then(response => {
                    this.$alert(`Batch succesvol aangemaakt.`, 'success')
                    this.$router.push({
                        name: 'ShipmentBatchView',
                        params: {
                            locationTypeIdentifier: this.location.location_type.identifier,
                            locationIdentifier: this.location.identifier,
                            batchIdentifier: response.data.identifier
                        },
                    })
                })
                .catch(e => {
                    console.error(e)
                    this.$alert(`Fout bij het aanmaken van de batch.\nProbeer het opnieuw of neem contact op met OmniStock.`, "danger")
                })
                .then(() => {
                    this.resetLoading()
                })
        },
        getPickZonesForDispatchRequest(drq) {
            return Object.values(_.uniq(drq.dispatch_request_lines.map(line => (line.storage_location) ? line.storage_location.id : null)).sort())
        },

        /*+ SELECT PICKZONES **/

        async getPickZones() {
            return this.$http.get(`/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}/storage-locations`, {
                params: {
                    type: 'pick',
                }
            })
                .then(response => {
                    _.each(this.pickZoneCombinationsWithDispatchRequests, (drqCount, combinationJson) => {
                        const combination = JSON.parse(combinationJson)
                        this.pickZones.push({
                            ids: combination,
                            display_name: combination
                                .map(id => response.data.find(z => z.id === id))
                                .map(zone => (zone) ? zone.display_name : '<i>onbekend</i>')
                                .join(' + '),
                            drqCount: drqCount,
                        })
                    })

                    this.pickZones = _.orderBy(this.pickZones, 'drqCount', 'desc')
                })
        },
        toggleZone(zone) {
            let index = this.getSelectedZoneIndex(zone)
            if (index === -1) {
                this.selectedPickZones.push(zone)
            }
            else {
                this.selectedPickZones.splice(index, 1)
            }
        },
        getSelectedZoneIndex(zone) {
            if (!this.selectedPickZones) {
                return -1
            }

            return this.selectedPickZones.findIndex(z => z.display_name === zone.display_name)
        },
        isZoneSelected(zone) {
            return this.getSelectedZoneIndex(zone) !== -1
        },

    },
}
</script>

<style scoped>
.pickzone-selected {
    background: #DDFFD8;
}
</style>
